export const imagenDefault = "sinimagen.jpg"
export const porcentaje_igv = 18
export const cantidad_decimales_venta = 2;
export const moneda_mostrar = "S/ "
export const cantidad_decimales_mostrar = 2
//export const Ruta = process.env.REACT_APP_RUTA_SISTEMA
//export const RutaLocal = process.env.REACT_APP_RUTA_PRINCIPAL
export const renderNumber = (number) => {
    return number.toLocaleString('es-ES', { style: 'currency', currency: 'PEN' })
}
/*export const TIPO_CAMBIO = async () => {
    return await fetch(`${Ruta}web/getUltimoTipoCambio`, {
        headers: { 'Authorization': '3885a650df6f71611c630ea550f9be2eb12a882d7eddf3c95fb0bf4967ed1538d7246783db6db577a98aacf490ef70d1d398fc1a543ef80ea8f035ac3ec1df38', },
    })
        .then(response => response.json())
        .catch(error => {
            console.log("error en API", error)
        })
} */
export const renderNumero = (numero) => {
    let numero_parse = parseFloat(numero)
    numero_parse = numero_parse.toFixed(cantidad_decimales_venta)
    numero_parse = parseFloat(numero_parse)
    return new Intl.NumberFormat('es-Pe', { "minimumFractionDigits": 2 }).format(numero_parse)
}
export const calcularPrecioFinal = (numero, tipo_igv = 14, moneda = 12, tipo_cambio = 3.78) => {
    //tipo_igv{14:gravado,15:exonerado|moneda:12 soles,13:dolares}
    try {
        if (moneda != 12) {
            numero = numero * tipo_cambio
        }
        if (tipo_igv != 15) {
            numero = numero * (1 + (porcentaje_igv / 100))
        }
        numero = parseFloat(numero)
        return parseFloat(numero.toFixed(2))
    } catch (error) {
        console.error("error con el number: ", numero, error);
        return 0;
    }

}
export const codeNombreProductoURL = (nombre) => {
    let producto_cambio_guion = (nombre || "").replaceAll('-', ';;')
    let producto_cambio_signo_mas = (producto_cambio_guion || "").replaceAll('+', '||') //cambio el '+' por el '||' para el servidor pueda leer bien el + y no lo lea como espacio
    let producto_url = producto_cambio_signo_mas.replaceAll(' ', '-')
    return producto_url
}
export const decodeNombreProductoURL = (nombre) => {//ojo siempre deben codificar y decodificar el name para buscar bien en la BD
    //console.log("antes de", nombre)
    let nombre_parse = decodeURI((nombre || "").replaceAll('-', ' '));
    nombre_parse = nombre_parse.replaceAll(';;', '-');
    nombre_parse = nombre_parse.replaceAll('"', '\"');
    nombre_parse = nombre_parse.replaceAll("'", "\'");
    return nombre_parse
}
export const distanciaEuclidiana = (a, b) => {
    const sumatoria = a.reduce((suma, valor, indice) => {
        const diferencia = valor - b[indice]
        return suma + diferencia * diferencia
    }, 0)
    return Math.sqrt(sumatoria)
}
export default {
    imagenDefault, renderNumero
}